import ReactGA from "react-ga4";

const TRACKING_ID = "G-GVEBVS5E4H"; // Replace with your Measurement ID

// Initialize Google Analytics
export const initializeGoogleAnalytics = () => {
  ReactGA.initialize(TRACKING_ID);
};

// Hook to track page views
export const trackPageView = (location) => {
  const pagePath = location.pathname + location.search + location.hash; // Include hash
  const hashFragment = location.hash ? location.hash : "no-hash";
  ReactGA.send({
    hitType: "pageview",
    page: pagePath,
    hash_fragment: hashFragment
  });
  
};
